import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { S3_BUCKET_URL } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import {
  OptionItemSquare,
  OptionItemSquareList,
} from '@/pages/Onboarding/components/OptionItemSquare';
import { useOnboarding } from '@/pages/Onboarding/context';
import {
  OwnAiTitle,
  OwnAiTitleHighlight,
} from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { OUTFIT_STYLE_OPTIONS } from '@/pages/Onboarding/options/OutfitStyle';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { ScreenOutfitStyleStyles } from './OutfitStyle.styles';

export const ScreenOutfitStyle: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'OutfitStyle',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const outfit_style = form.watch('outfit_style');

  const handleSelect = (
    option: OnbOptionType<LayoutDataType['outfit_style']>,
  ) => {
    form.setValue('outfit_style', option.id);
    userService.createOrUpdate({
      onboarding_data: {
        outfitStyle: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  const getOptionImage = (
    option: OnbOptionType<LayoutDataType['outfit_style']>,
  ) => {
    return `${S3_BUCKET_URL}/own-ai-roleplay-rooms/outfit-style/${option.id}.png`;
  };

  return (
    <ScreenOutfitStyleStyles background={'dark-solid'}>
      <OnboardingNavigation />
      <OwnAiTitle>
        Choose <OwnAiTitleHighlight>outfit</OwnAiTitleHighlight> style
      </OwnAiTitle>
      <IonContent>
        <OptionItemSquareList>
          {OUTFIT_STYLE_OPTIONS.map((option) => (
            <OptionItemSquare
              key={option.id}
              isSelected={outfit_style === option.id}
              onClick={() => handleSelect(option)}
              bgSrc={getOptionImage(option)}
              title={option.title}
              TEST_ID={`outfit_style-${option.id}`}
            />
          ))}
        </OptionItemSquareList>
      </IonContent>
    </ScreenOutfitStyleStyles>
  );
};
